import { useState } from "react";
import { useEffect } from "react";
import React, { useRef } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { isValidPhoneNumber } from "react-phone-number-input";

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import { Loader } from "../../common/loader";
import AlertDialog from "../../common/AlertDialog";
import { MenuProps } from "../../helpers/constants";
import CustomTextField from "../../common/CustomTextField";
import { getObjLength } from "../../helpers/utils";
import CustomPhoneNumberInput from "../../common/CustomPhoneNumberInput";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import { serviceProviderSignupAction } from "../../../redux/slices/serviceProvider/SPSignUpSlice";
import { fieldsValidations } from "../../Service-Provider/signup/SPSignupForm";

const CreateServiceProviderForm = ({
  setScreen,
  from = "",
  setIsOTPByPass,
  isOTPByPass,
  goBack = () => {},
}) => {
  const dispatch = useDispatch();
  const signUpFormRef = useRef();
  const cropperRef = useRef();

  const [openPopup, setOpenPopup] = useState(false);
  const [inputParams, setInputParams] = useState({});
  const [isOtpConfirmationModalOpen, setIsOtpConfirmationModalOpen] =
    useState(false);

  const stateData = useSelector((state) => state.signUpUser.stateList);
  const { spSignupLoader, createAccResponse, professionalsList } = useSelector(
    (state) => state.serviceProviderSignup
  );

  const { confirm_password, password, ...SpSchema } = fieldsValidations;

  const onSubmit = (values, errors) => {
    console.log(isOTPByPass, "values=>", values);

    setInputParams(values);
    setIsOtpConfirmationModalOpen(true);
    // setScreen();
  };

  // handle otp confirmation modal
  const handleCreateUser = (isOTPByPass) => {
    setIsOTPByPass(isOTPByPass);
    setIsOtpConfirmationModalOpen(false);
    let data = { ...inputParams, is_bypass: isOTPByPass };
    if (isOTPByPass) {
      data = { ...data, step_key: "VERIFY_EMAIL_OTP", step: 1 };
    } else {
      data = { ...data, step_key: "SEND_OTP", step: 0 };
    }
    console.log("final data==>>", data);
    localStorage.setItem("spSignupDetails", JSON.stringify(data));

    const formData = new FormData();

    Object.keys(data)?.map((key) => formData.append(key, data[key]));

    // return console.log("final form data==>", formData);
    // let url = "service-provider/send-otp";
    // if (from === "Admin") {
    let url = "admin/service-provider/create";
    // }
    dispatch(
      serviceProviderSignupAction.spSignupData({
        url: url,
        data: formData,
        token: true,
        isFile: true,
      })
    );
  };

  useEffect(() => {
    dispatch(userSigupAction.getState({ url: "states", data: {} }));
    dispatch(
      serviceProviderSignupAction.getProfessionals({
        url: "service-provider/types",
        data: {},
      })
    );
  }, [dispatch]);

  useEffect(() => {
    console.log("createAccResponse==>", createAccResponse);
    if (getObjLength(createAccResponse)) {
      if (createAccResponse?.success) {
        if (!isOTPByPass) {
          setScreen("token");
        } else {
          // setScreen("Professional info");
          goBack();
        }
        // setScreen();
      } else {
        setOpenPopup(true);
      }
    }
  }, [createAccResponse]);

  return (
    <Box>
      <Formik
        enableReinitialize
        validateOnChange
        initialValues={{
          first_name: "",
          last_name: "",
          company_name: "",
          ofc_address: "",
          ofc_city: "",
          ofc_state: "",
          ofc_zip: "",
          email: "",
          type: "",
          ofc_phone: "",
        }}
        innerRef={signUpFormRef}
        validationSchema={Yup.object().shape({
          ...SpSchema,
        })}
        // onSubmit={onSubmit}
        onSubmit={(values, validation) => {
          if (!isValidPhoneNumber(values?.ofc_phone)) {
            return;
          }

          // return console.log("values", values);
          onSubmit(values);
        }}
      >
        {({ values, setFieldValue, touched, errors }) => {
          return (
            <Form>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="First name"
                    name="first_name"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="Last name"
                    name="last_name"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="Email"
                    name="email"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="Company Name"
                    name="company_name"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="Company Address"
                    name="ofc_address"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomPhoneNumberInput
                    name="ofc_phone"
                    placeholder="Company Phone number"
                    values={values}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    otherProps={{
                      onChange: (event) => {
                        setFieldValue("ofc_phone", event);
                        setFieldValue("phone_number", event);
                        if (!event) {
                          setFieldValue("ofc_phone", "");
                          setFieldValue("phone_number", "");
                        }
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="Company City"
                    name="ofc_city"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <FormControl
                    fullWidth
                    className="sign-textField"
                    error={touched.ofc_state && Boolean(errors.ofc_state)}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Company State
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-placeholder"
                      id="demo-simple-select"
                      value={values?.ofc_state}
                      label="Company State"
                      name="ofc_state"
                      variant="outlined"
                      onChange={(event) => {
                        setFieldValue("ofc_state", event.target.value);
                      }}
                      MenuProps={MenuProps}
                      // displayEmpty
                    >
                      <MenuItem disabled value="">
                        <span style={{ color: "#00000075" }}>State</span>
                      </MenuItem>
                      {stateData?.map((ofc_state) => (
                        <MenuItem value={ofc_state.name}>
                          {ofc_state.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.ofc_state && Boolean(errors.ofc_state) && (
                      <FormHelperText sx={{ color: "#d32f2f" }}>
                        {touched.ofc_state && errors.ofc_state}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <CustomTextField
                    label="Company Zip"
                    name="ofc_zip"
                    validation={{
                      values,
                      setFieldValue,
                      touched,
                      errors,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} px={1} pb={1}>
                  <FormControl
                    fullWidth
                    className="sign-textField"
                    error={touched.type && Boolean(errors.type)}
                  >
                    <InputLabel id="demo-simple-select-placeholder">
                      Professional type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-placeholder"
                      id="demo-simple-select"
                      value={values?.type}
                      label="Professional type"
                      name="type"
                      variant="outlined"
                      onChange={(event) => {
                        setFieldValue("type", event.target.value);
                      }}
                      MenuProps={MenuProps}
                      // displayEmpty
                    >
                      <MenuItem disabled value="">
                        <span style={{ color: "#00000075" }}>Type</span>
                      </MenuItem>
                      {professionalsList?.data?.map((val) => (
                        <MenuItem value={val.id}>{val.type}</MenuItem>
                      ))}
                    </Select>
                    {touched.type && Boolean(errors.type) && (
                      <FormHelperText sx={{ color: "#d32f2f" }}>
                        {touched.type && errors.type}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid xs={12} md={12} px={1} pb={1}>
                  <div className="text-center createAcBtn mt-5">
                    <Button
                      type="submit"
                      className="next_button"
                      variant="contained"
                    >
                      Create your account
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
      {getObjLength(createAccResponse) && openPopup && (
        <AlertDialog
          type="Error"
          openPopup={openPopup}
          onClose={true}
          mesage={
            // {<p className="text-center text-danger m-0">
            !createAccResponse?.data?.success &&
            createAccResponse?.data?.message
          }
          onCloseFun={() => setOpenPopup(false)}
          // </p>}
        />
      )}
      <Loader open={spSignupLoader} />
      {/* otp confirmation modal */}
      {isOtpConfirmationModalOpen && (
        <>
          <AlertDialog
            type="Info"
            openPopup={isOtpConfirmationModalOpen}
            onClose={true}
            onCloseFun={() => {
              handleCreateUser(false);
            }}
            mesage={
              "Do you want this user to bypass the Token confirmation process?"
            }
            footer={false}
            buttons={
              <>
                <Button
                  className="popup_Btn other_popup_btn mx-2"
                  onClick={() => handleCreateUser(false)}
                >
                  No
                </Button>
                <Button
                  className="popup_Btn success_popup_btn mx-2"
                  onClick={() => handleCreateUser(true)}
                >
                  Yes
                </Button>
              </>
            }
          />
        </>
      )}
    </Box>
  );
};

export default CreateServiceProviderForm;
